import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import { Button, Grid, Box, CircularProgress } from '@mui/material'
import { Formik, Form } from 'formik'
import { TextField, FormDropdown, RolesComplexDropdownItemFactory } from 'src/components/ui'
import { UserContractor, UserRole } from 'src/api'
import { UserRoles } from 'src/enums'
import { useUserRoleListRequest } from 'src/hooks/api'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().required('Email is required').email('Email is invalid')
})

export interface UserContractorEditState {
  name: string;
  email: string;
  roleId: number;
}

interface UserContractorEditFormProps {
  initialValues: UserContractor;
  isLoading?: boolean;
  onSubmit: (data: UserContractorEditState) => void;
}

export const UserContractorEditForm: FC<UserContractorEditFormProps> = ({
  initialValues,
  isLoading = false,
  onSubmit
}) => {
  const navigate = useNavigate()
  const rolesRequest = useUserRoleListRequest({ params: { limit: 100 } })
  const roles: UserRole[] = rolesRequest.data?.rows || []
  const isGeneralContractor = initialValues.role?.name === UserRoles.GeneralContractor

  const formInitialValues: UserContractorEditState = {
    name: initialValues.name || '',
    email: initialValues.email || '',
    roleId: initialValues.roleId
  }

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values) => {
        onSubmit(values)
      }}
    >
      {({ errors }) => {
        const hasErrors = Object.keys(errors).length > 0
        return (
          <Form>
            <Box width="900px" maxWidth="100%">
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField name="name" label="Name" required />
                </Grid>
                <Grid item xs={12}>
                  <TextField name="email" label="Email" required />
                </Grid>
                {!isGeneralContractor && (
                  <Grid item xs={12}>
                    <FormDropdown
                      list={roles}
                      name="roleId"
                      label="Role"
                      required
                      menuItemFactory={RolesComplexDropdownItemFactory({
                        labelProp: 'displayName',
                        valueProp: 'id'
                      })}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box display="flex" gap={2} mt={2}>
                    <Button variant="outlined" onClick={() => navigate(-1)}>
                      Back
                    </Button>
                    <Button type="submit" variant="contained" disabled={hasErrors || isLoading}>
                      {isLoading ? <CircularProgress color="info" size={26} /> : 'Save'}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}
